<template>
  <div class="w-100 h-100" :style="backGroundColor" style="position: relative">
    <!-- ドラッグ出来ないようにdivで表示 -->
    <div
      ref="designImage"
      class="design"
      :style="getDesignImageStyle"
    />
    <div
      ref="cutlineImage"
      class="cutLine"
      :style="getCutlineImageStyle"
    />
    <!-- <canvas ref="canvas" class="w-100 h-100 cutLine"></canvas> -->
  </div>
</template>

<script>
import { PreviewColorList, GetCanvasSize } from "@/js/Const.js";
// import { CreateImageElement } from "@/js/CommonFunc.js";

export default {
  name: "CenterViewPreview2d_Ap",
  props: {},
  data: function () {
    return {
      canvas: null,
    };
  },
  watch: {
    // "$store.state.cutlineImageURL":async function(){
    //   let image = await CreateImageElement(this.$store.state.cutlineImageURL);
    //   this.canvas.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
    // },
    // "$store.state.scFrameCutlineImageURL":async function(){
    //   let image = await CreateImageElement(this.$store.state.scFrameCutlineImageURL);
    //   this.canvas.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
    // },
  },
  async created() {
    console.log("created");

    this.canvas = this.$refs.canvas;

    // if( this.$store.state.cutlineImageURL ){
    //   let image = await CreateImageElement(this.$store.state.cutlineImageURL);
    //   this.canvas.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
    // }

    // if( this.$store.state.scFrameCutlineImageURL ){
    //   let image = await CreateImageElement(this.$store.state.scFrameCutlineImageURL);
    //   this.canvas.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
    // }
  },
  computed: {
    getDesignImageStyle() {
      let canvasSize = GetCanvasSize(this.$store.state.commonPreviewData.selectProductId);
      return {
        "background-image": 'url("' + this.$store.state.commonPreviewData.designImageURL + '"',
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
      };
    },
    getCutlineImageStyle() {
      let canvasSize = GetCanvasSize(this.$store.state.commonPreviewData.selectProductId);
      return {
        "background-image": 'url("' + this.$store.state.commonPreviewData.frameCutlineImageURL + '"',
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
      };
    },
    backGroundColor() {
      return {
        "background-color": PreviewColorList[this.$store.state.commonPreviewData.selectBackgroundColor],
      };
    },
  },
  unmounted() {
    console.log("2d unmounted");
  },
  mounted() {
    console.log("2d mounted");
  },
  destroyed() {
    console.log("2d destroyed");
  },

  components: {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.design {
  /* top:0;
  left:0; */
  /* width:437px;
  height:700px; */
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.cutLine {
  /* top:0;
  left:0; */
  /* width:437px;
  height:700px; */
  /* opacity:.15; */
  position: absolute;
  background-repeat: no-repeat;
  background-size: contain;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}
</style>
